import { render, staticRenderFns } from "./CopyWidgetDlg.vue?vue&type=template&id=4f04ca2b"
import script from "./CopyWidgetDlg.vue?vue&type=script&lang=ts"
export * from "./CopyWidgetDlg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports